<div class="d-flex flex-column justify-content-center align-items-center h-100 position-relative text-center p-4">
    <p *ngIf="data?.msg != undefined" class="h5 text-dark pb-4">{{ data?.msg }}</p>
    <p *ngIf="data?.msg == undefined" class="h5 text-dark pb-4">Something Went Wrong!</p>
    
    <button mat-flat-button mat-dialog-close color="primary" class="position-absolute bottom-0 mb-4">Close</button>
</div>


